import * as React from 'react';
import { cn } from '../lib/utils';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'flex w-full rounded-md border border-line-strong bg-surface px-3 py-2',
        'font-sans text-base text-ink',
        'placeholder:text-ink-faint',
        'outline-none transition-colors resize-y',
        'focus-visible:border-brand focus-visible:ring-2 focus-visible:ring-brand/25',
        'disabled:opacity-60 disabled:bg-surface-sunk',
        className
      )}
      {...props}
    />
  )
);
Textarea.displayName = 'Textarea';

export { Textarea };
